import { ComponentProps, forwardRef } from "react";

export const LoadingSpinner = forwardRef<
  HTMLSpanElement,
  Omit<ComponentProps<"span">, "className">
>((props, ref) => {
  return <span className="loading-spinner" ref={ref} {...props} />;
});

export default LoadingSpinner;
